import { Component } from '@angular/core';

@Component({
	selector: 'ac-pdf-generate-skeleton',
	templateUrl: './pdf-generate-skeleton.component.html',
	styleUrls: ['./pdf-generate-skeleton.component.scss']
})
export class PdfGenerateSkeletonComponent {
	public GHOST_ROWS = Array(2).fill(0);
}
